import { PermissionsEnum } from "@/auth/interfaces";
import SaveNaps from "../../shared/saveNaps/saveNaps";
import { useCheckPermissions } from "@/shared";

export interface CreateNapsPageInterface {}

const CreateNapsPage: React.FC<CreateNapsPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_nap)
  return <SaveNaps titlePage="Crear NAP" />;
};

export default CreateNapsPage;
